import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { consumeLoginAsHandoff } from "../utils/authStorage";
import { getDefaultPathForRole } from "../utils/rolePermissions";

const LoginAsPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { bootstrapLoginAs } = useAuth();
  const [error, setError] = useState("");
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const key = searchParams.get("key");
    const handoff = consumeLoginAsHandoff(key);

    if (!handoff) {
      setError(
        "Login link expired or invalid. Please try again from Users Management.",
      );
      return;
    }

    bootstrapLoginAs(handoff.token, handoff.user);
    navigate(getDefaultPathForRole(handoff.user?.role), { replace: true });
  }, [bootstrapLoginAs, navigate, searchParams]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        background: "#f8f9fa",
        padding: "1.5rem",
      }}
    >
      <div
        style={{
          background: "#fff",
          border: "1px solid #eee",
          borderRadius: "12px",
          padding: "2rem",
          maxWidth: "420px",
          width: "100%",
          textAlign: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
        }}
      >
        {error ? (
          <>
            <p style={{ color: "#dc3545", marginBottom: "1rem" }}>{error}</p>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => navigate("/login", { replace: true })}
            >
              Go to Login
            </button>
          </>
        ) : (
          <>
            <p style={{ margin: 0, fontWeight: 600 }}>Opening account...</p>
            <p
              style={{
                margin: "0.5rem 0 0",
                color: "#6c757d",
                fontSize: "0.95rem",
              }}
            >
              Setting up the new tab session.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginAsPage;
